import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OptionQuest } from 'src/app/enums/option-question.enum';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-add-question',
  templateUrl: './add-question.component.html',
  styleUrls: ['./add-question.component.scss']
})
export class AddQuestionComponent implements OnInit {
  optionsQuest: any[]=[];
  optionSelected: any;
  
  constructor(
    public dialogRef: MatDialogRef<AddQuestionComponent>,
    private adminservice: AdminService
  ) { }

  ngOnInit() {
    //let tempList = [...OptionQuest];
    //this.optionsQuest = tempList;
    this.getOptionsQuest();
  }

  changeState(option:any){
    this.optionSelected = option.value;
    this.optionsQuest.forEach(element=>element.state = false);
    option.state = !option.state;
  }

  guardarOptionQuestion(){
    this.dialogRef.close(this.optionSelected);
  }

  getOptionsQuest(){
    this.adminservice.getTypeQuestions().subscribe(
      (response)=>{
        this.optionsQuest = response;
      }
    );
  }

}
